import React, { Component } from 'react'
import MainMenu from './mainMenu'
import SubMenu from './subMenu'
import SpaItemInfo from './spaItemInfo'
import MyReservations from './myReservations'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { setDeviceLoginPage } from '../../action/action'
//import { } from ''

class Spa extends Component {

    componentDidMount() {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room")
        if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
            console.log("h-commerce widget: no session token");
            if (this.props.currentWidget.widgetType && (!room || room === "null")) {
                this.props.setDeviceLoginPage(true);
                console.log("room", room);
            } else {
                console.log("there is some bug in guest registration flow.");
            }
        }
    }

    getPage = () => {
        switch (this.props.currentPage) {
            case "mainMenu":
                return <MainMenu />
            case "myReservations":
                return <MyReservations />
            case "subMenu":
                return <SubMenu />
            case "spaItemInfo":
                return <SpaItemInfo />
            default:
                return <MainMenu />
        }
    }
    render() {
        return (
            <div id="ico-spa" class="contentSection tile-section">

                {this.getPage()}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentPage: state.store.spa.currentPage,
        currentWidget: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
    }
}

export default connect(
    mapStateToProps,
    {
        setDeviceLoginPage
    }
)(Spa);